// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-views-pages-404-tsx": () => import("./../../../src/views/pages/404.tsx" /* webpackChunkName: "component---src-views-pages-404-tsx" */),
  "component---src-views-pages-index-tsx": () => import("./../../../src/views/pages/index.tsx" /* webpackChunkName: "component---src-views-pages-index-tsx" */),
  "component---src-views-pages-info-tsx": () => import("./../../../src/views/pages/info.tsx" /* webpackChunkName: "component---src-views-pages-info-tsx" */)
}

